import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
  Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, ArrowBack } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useAuth } from '../context/AuthContext';

const Error = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();
  const { currentUser } = useAuth();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 6 },
            borderRadius: 3,
            maxWidth: 600,
            width: '100%',
          }}
        >
          {/* Icône 404 */}
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '4rem', sm: '6rem' },
              mb: 2,
            }}
          >
            🔍
          </Typography>

          {/* Code 404 */}
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '3rem', sm: '4rem' },
              fontWeight: 'bold',
              color: theme.palette.primary.main,
              mb: 1,
            }}
          >
            404
          </Typography>

          {/* Titre */}
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontSize: { xs: '1.5rem', sm: '2rem' },
              fontWeight: 'bold',
              mb: 2,
            }}
          >
            {t('error.notFound.title')}
          </Typography>

          {/* Message */}
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              mb: 4,
              fontSize: { xs: '0.9rem', sm: '1rem' },
              lineHeight: 1.6,
            }}
          >
            {t('error.notFound.message')}
          </Typography>

          {/* Actions */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Button
              variant="contained"
              startIcon={<Home />}
              onClick={handleGoHome}
              size="large"
              sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
            >
              {t('error.actions.goHome')}
            </Button>

            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={handleGoBack}
              size="large"
              sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
            >
              {t('error.actions.goBack')}
            </Button>

            {currentUser && (
              <Button
                variant="outlined"
                onClick={handleGoToDashboard}
                size="large"
                sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
              >
                {t('error.actions.dashboard')}
              </Button>
            )}
          </Stack>
        </Paper>
      </Box>
    </Container>
  );
};

export default Error;
